/**
 * Type of allowed binds.
 * - Click event;
 * - Focus event;
 * - Blur event;
 */
export type HjBind = 'click' | 'focus' | 'blur';
